"use client";

import styles from "@/styles/global/footer.module.scss";
import Image from "next/image";
import Link from "next/link";
import { useAppSelector } from "@/store/hooks";
import { usePathname } from "next/navigation";
import { isPaymentMethodVisible } from "@/utils/paymentAvailability";

// interface SocialLinkType {
//   title: string;
//   href: string;
//   src: string;
// }

interface PaymentMethodType {
  title: string;
  src: string;
}

interface ExtraType {
  title: string;
  url: string;
}

export default function Footer() {
  const pathname = usePathname();
  const showFullFooter =
    !pathname.includes("/checkout") &&
    !pathname.includes("/payment-result/") &&
    !pathname.includes("/account/my-addresses") &&
    !pathname.includes("/account/create-address") &&
    !pathname.includes("/account/edit-address") &&
    !pathname.startsWith("/review/write-review/") &&
    !pathname.includes("/my-account/");;

  // 蜜罐链接仅在指定页面生效
  const showHoneypot =
    pathname === "/" ||
    pathname.startsWith("/online-") ||
    pathname.startsWith("/search/") ||
    pathname.startsWith("/shop/") ||
    pathname === "/article/return" ||
    pathname === "/crazysalesoftheday" ||
    pathname === "/new-arrivals" ||
    pathname === "/free-shipping" ||
    pathname === "/hottest-deals" ||
    pathname === "/clearance" ||
    pathname === "/featured-deals";


  // 从Redux store获取用户状态
  const { hasLogin } = useAppSelector((state) => state.user);

  if (pathname === "/checkout") {
    return null;
  }

  // const socialLinks = [
  //   {
  //     title: "Facebook",
  //     href: "https://www.facebook.com/CrazySales.com.au/",
  //     src: `//img.crazysales.com.au/images/newhomepage/mobile/svg/social/icon-social-fb-color.svg`,
  //   },
  //   {
  //     title: "YouTube",
  //     href: "https://www.youtube.com/@AUSWay",
  //     src: `//img.crazysales.com.au/images/newhomepage/mobile/svg/social/icon-social-ytb-color.svg`,
  //   },
  //   {
  //     title: "Twitter",
  //     href: "https://twitter.com/CrazySalesAus",
  //     src: `//img.crazysales.com.au/images/newhomepage/mobile/svg/social/icon-social-tw-color.svg`,
  //   },
  //   {
  //     title: "Instagram",
  //     href: "https://www.instagram.com/crazysalescomau/",
  //     src: `//img.crazysales.com.au/images/newhomepage/mobile/svg/social/icon-social-ins-color.svg`,
  //   },
  //   {
  //     title: "Pinterest",
  //     href: "https://au.pinterest.com/crazysales/",
  //     src: `//img.crazysales.com.au/images/newhomepage/mobile/svg/social/icon-social-pin-color.svg`,
  //   },
  //   {
  //     title: "Blog",
  //     href: "http://blog.crazysales.com.au/",
  //     src: `//img.crazysales.com.au/images/newhomepage/mobile/svg/social/icon-social-bg-color.svg`,
  //   },
  // ];

  const paymentMethodList = [
    {
      title: "Visa",
      src: `${process.env.IMAGE_DOMAIN}/svg/payment-method/VISA.svg`,
    },
    {
      title: "Mastercard",
      src: `${process.env.IMAGE_DOMAIN}/svg/payment-method/Mastercard.svg`,
    },
    {
      title: "PayPal",
      src: `${process.env.IMAGE_DOMAIN}/svg/payment-method/Paypal.svg`,
    },
    {
      title: "Afterpay",
      src: `${process.env.IMAGE_DOMAIN}/svg/payment-method/Afterpay.svg`,
    },
    {
      title: "Apple Pay",
      src: `${process.env.IMAGE_DOMAIN}/svg/payment-method/Applepay.svg`,
    },
    {
      title: "Google Pay",
      src: `${process.env.IMAGE_DOMAIN}/svg/payment-method/google-pay.svg`,
    },
  ].filter(isPaymentMethodVisible);

  const extraList = [
    {
      title: "Terms & Use",
      url: "/article/terms",
    },
    {
      title: "Shipping Guide",
      url: "/article/shipping",
    },
    {
      title: "Warranty Policy",
      url: "/article/warranty",
    },
    {
      title: "About US",
      url: "/article/AboutUs",
    },
    {
      title: "Privacy Policy",
      url: "/article/privacy",
    },
    {
      title: "Contact US",
      url: "/contact",
    },
    {
      title: "Newsletter",
      url: "/newsletters/index",
    },
    {
      title: "Afterpay",
      url: "/afterpay",
    },
    {
      title: "Zippay",
      url: "/zippay",
    }
  ].filter(isPaymentMethodVisible);

  return (
    <div className={styles["comp-footer"]}>
      {showFullFooter ? (
        <>
          {/* <div className={styles["social-media-box"]}>
            <Link
              key={"thread"}
              href={"https://www.threads.net/@crazysalescomau"}
            >
              <Image
                className={styles["social-media-item-logo"]}
                src={`${process.env.IMAGE_DOMAIN}/home/threads-icon.png`}
                alt={"thread"}
                width={35}
                height={35}
              />
            </Link>
            {socialLinks.map((social: SocialLinkType) => (
              <Link key={social.title} href={social.href}>
                <Image
                  className={styles["social-media-item"]}
                  src={social.src}
                  alt={social.title}
                  width={40}
                  height={40}
                />
              </Link>
            ))}
          </div>

          <Link href={"/category"} className={styles["all-categories"]}>
            All Categories
          </Link> */}

          <div className={styles["accept-title"]}>We proudly accept:</div>

          <div className={styles["accept-payment-list"]}>
            {paymentMethodList.map((payment: PaymentMethodType) => (
              <Image
                className={styles["accept-payment-item"]}
                key={payment.src}
                src={payment.src}
                alt={payment.title}
                width={47}
                height={27}
              />
            ))}
          </div>

          {!hasLogin ? (
            <div className={styles["login-tips"]}>
              Please
              <Link href={"/login"}>
                <span className={styles["login-link"]}>Sign in</span>
              </Link>
              if you are already a customer.
            </div>
          ) : null}

          <Link href={"https://www.bestdeals.co.nz/?fullsite=1"}>
            <div className={styles["full-site"]}>Go to Full Site</div>
          </Link>

          <div className={styles["extra-site-list"]}>
            {extraList.map((extra: ExtraType) => (
              <Link
                className={styles["extra-site-item"]}
                href={extra.url}
                key={extra.url}
              >
                {extra.title}
              </Link>
            ))}
          </div>
        </>
      ) : null}

      <div
        className={styles["copy-right"]}
        style={
          pathname == "/checkout" ||
          pathname.includes("/online-") ||
          pathname.includes("/view-cart")
            ? { paddingBottom: "90px" }
            : { paddingBottom: "24px" }
        }
      >
        Copyright &copy; 2012 - {new Date().getFullYear()} Best Deals. All rights reserved
      </div>

      {showHoneypot && (
        <a
          href="/whycanseeme.html"
          rel="nofollow"
          style={{ display: "none" }}
          aria-hidden
        ></a>
      )}
    </div>
  );
}
